import { deepSetObject, digObject } from '@domain-group/javascript-utils'

import { UseFormPayload } from '@domain-group/react-hooks'

import useAgencies from '@hooks/useAgencies'
import useBrand from '@hooks/useBrand'

import handleCallbackAction from '@functions/handleCallbackAction'

import type { BrandModel } from '@models/types'

interface UpdateBrandImagePermissionsParams {
  entityState: UseFormPayload['entityState'],
  isBrandControlledSettings: boolean,
  setEntityState: UseFormPayload['setEntityState'],
  updateBrandFn:(brandParams: BrandModel) => void,
}

const updateBrandImagePermissions = (params: UpdateBrandImagePermissionsParams) => {
  const {
    entityState, isBrandControlledSettings, setEntityState, updateBrandFn,
  } = params

  const updatedState = deepSetObject(
    entityState,
    'options.brand_controlled_image_settings_enabled',
    !isBrandControlledSettings,
  )

  // @ts-expect-error TS2345
  setEntityState(updatedState)

  const updateBrandImagePermissionsPayload = {
    callbacks: {
      action: updateBrandFn,
    },
    entityParams: updatedState,
    toastText: 'Brand Image Settings Permissions Updated',
  }

  // @ts-expect-error TS2345
  return handleCallbackAction(updateBrandImagePermissionsPayload)
}

type UseBrandImageSettingsParams = {
  brandId: number,
}

function useBrandImageSettings(params: UseBrandImageSettingsParams) {
  const { brandId } = params

  const useBrandPayload = useBrand({ id: brandId })
  const { brand, callbacks: { updateBrand: updateBrandFn } } = useBrandPayload

  const { filteredAgenciesCount } = useAgencies({
    filters: { brand_id: brandId },
    performHttpRequests: !!brandId,
  })

  const excludedAgenciesCount = digObject(brand, 'options.brand_image_settings_excluded_agency_ids', []).length

  return {
    callbacks: {
      updateBrandImagePermissions: (
        isBrandControlledSettings: boolean,
        entityState: UseFormPayload['entityState'],
        setEntityState: UseFormPayload['setEntityState'],
      ) => updateBrandImagePermissions({
        entityState,
        isBrandControlledSettings,
        setEntityState,
        updateBrandFn,
      }),
    },
    excludedAgenciesCount,
    filteredAgenciesCount,
  }
}

export default useBrandImageSettings
